import { render, staticRenderFns } from "./bindProject.vue?vue&type=template&id=5635348b&"
import script from "./bindProject.vue?vue&type=script&lang=js&"
export * from "./bindProject.vue?vue&type=script&lang=js&"
import style0 from "./bindProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports